class TwoColumnContentBlock {
	constructor() {
		this.elements = document.querySelectorAll('.two-column-section');

		if (this.elements.length > 0) {
			this.init();
		}
	}

	init() {
	}
}